import { UserPushSettings } from './push';

class UserSettings {
  push;

  populate(data) {
    this.push = new UserPushSettings(data.push || {});
  }

  constructor(data) {
    this.populate(data || {});
  }
}

export { UserSettings };
